/*============================================================================
Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() { 
$cart = $("#cart");
$.ajax({
  url: '/cart.js',
  dataType: 'json',
  type: 'post',
  data: $cart.serialize(),
  success: function (data) { 
    refreshCart(data);
  }
});
}

function refreshCart(cart) { 
    $cartBtn = $(".icon-cart span");
   
    if ($cartBtn && $cartBtn.size()) {  
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      var cartSpecialMessage = "";
      
      //alert(shopCurrency);
      
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();
      
      if (cart.item_count <= 0) { 
        
        $cart.html('');
        $cart.append("<li class='empty_cart text-center'>Your Bag is Empty</li>");                                         
        $(".cart-button").removeClass('itemincart');             
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>');
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));    
        $(".addbag_count").hide();
        
      } else { 
        
        $.each(cart.items, function(index, item) {
          cart_items_html += '';
          cart_items_html += '<li class="cart_item last_cart_item">' +
			 '<div class="cart_image">' +
             '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" style="width:100%" />' +
             '</div>' +
			 '<div class="cart_item_right" data-qty="'+ item.quantity +'" data-sku="'+ item.sku +'" data-aus-product-url="https://nicholas-aus.myshopify.com/products/'+ item.handle + '.json">' +
			 '<div class="item_title cart_item_title">' + item.title + '</div>' +
            '<div class="price item_price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) +'</div>' +
			 '<div class="provar">' +
			 '<div>Size: ' + item.variant_title + '</div>' +
             '</div>' +
 			 '<div class="bottom_wrapper"><label>quantity:</label>' +
             '<div class="mm-counter cart-quantity">' +
             '<div class="overlay_qty_ajaxcart"></div>' +
             '<span class="quantity-count minus ss-icon minus">&#x002D;</span>' +
             '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
             '<span class="quantity-count plus ss-icon plus">&#x002B;</span>' +
             '</div>' +
             '<div class="removelink">' +
			 '<a href="javascript:void(0)" class="removelink_del" onclick="remove_item(' + item.variant_id + '); return false;">remove</a>' +
			 '</div>' +
			 '</div>' +
			 '</div>' +
			 '</li>' ; 
			 /*'<a href="' + item.url +'">' +
             '<strong class="price">' + Shopify.formatMoney(item.line_price, $cart.data('money-format')) + '</strong>' +
             '</a>' +
             '</li>';*/
        });
		
		 
		cart_items_html += '<div class="totals_wrapper"><div class="subtotal"> <span>Total</span>' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) +'</div>' +
		  //'<div class="special_cart_message">'+ cartSpecialMessage +'</div>' + 
          '<div style="clear:both;"><input type="submit" value="Checkout" class="action_button right"></div><div class="col-md-12 text-center Cart_link"><a href="/cart">View Cart</a></div></div>';
          
		
        
         if( $(".cart_item").length > 1) { // You were checking for the length of the current td instead of the length for td's with the same class
       	   	$(".scrollbar").css('overflow-y', 'scroll');        
        } else {
          	$(".scrollbar").css('overflow-y', 'inherit');
        }
                
        $(".cart-button").addClass('itemincart');
        
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' +cart.item_count+ ')</a>');
          
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));  

        $cart.html(cart_items_html);
        //$cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
     
          if($('.currencies:visible option:selected').val()) {
            Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val()); 
          }
        
        
        if( $(".cart_item").length > 1) { // You were checking for the length of the current td instead of the length for td's with the same class
       	   	$(".scrollbar").css('overflow-y', 'scroll');        
        } else {
          	$(".scrollbar").css('overflow-y', 'inherit');
        }
        
        
		$(".product_bg").fadeIn(300);
		$("#added-box-wrapper").addClass("showcart");
      	
        $(".addbag_count").show();
        $('.template-collection .modal').fadeOut();
        $('body').removeClass('modal-open');
        $('.close-reveal-modal').click();
        
        //
        var wheight = $(window).height();
    	var header_height = $('#shopify-section-header').height();
    	var boxheight = $("#added-box-wrapper").innerHeight();
    	var total_height = $(".totals_wrapper ").innerHeight();
    
    	$("#added-box-wrapper").css('height', (wheight));
  		$("#added-box ul").css('height', (boxheight - 207 - 20));
        
        $('.cart_close, .cart_bg').click(function(){
        $(".cart-product").removeClass('cart-open');
          $(".cart_bg").removeClass('in');  
        });
        
        setTimeout(function() { 
          	$("#added-box-wrapper").removeClass("showcart");
          $(".product_bg").fadeOut(300);
        }, 8000); 
        
        setTimeout(function(){
          $(".cart-product").addClass('cart-open');
          $(".cart_bg").addClass('in');

        }, 5000);

      }
    }
  }  
  
function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }} 	
	
function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  ajaxSubmitCart();
}	
	
  
$(document).on("change", "#cart input", function() { 
  	//alert('1');
    ajaxSubmitCart();
});  
  


$(document).on("click", ".minus", function() { 
  
  	
  	var quantity = parseInt($(this).next("input").val()); 
    var qty = quantity ;
    
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    
    if (qty <= 0) {
   		$(this).closest('li.cart_item').addClass('animated fadeOutUp')
      	setTimeout(ajaxSubmitCart, 500);
    } else {
      	ajaxSubmitCart();
    }
  });  

$(document).on("click", ".plus", function() {  	  	
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
   
  	ajaxSubmitCart();
});
  

$(document).on("submit",".product_form", function(e) { 
      e.preventDefault();
      var $addToCartForm = $(this);  
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

  //added delay of 1 second in form submission
  setTimeout( function () {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(itemData) { 
    	  $.getJSON("/cart.js", function(cart) { 
            refreshCart(cart);
            window.setTimeout(function(){ $('.cart-button').click(); }, 500);
          }); 
          
         
          
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          //var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartBtn.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Basket").removeClass('zoomOut').addClass('zoomIn');
        }
      });
  }, 1000);
  
      return false;
});


$(".product_bg, .coll_close").click(function() {
  	$("#added-box-wrapper").removeClass("showcart");
  
  	$(".product_bg").hide();
  
  	 setTimeout(function() { 
   		//$("body").removeClass('no-scroll');
   }, 1500);  
});